import React, { Component } from "react";
import client from "@culturehq/client";
import { Button, Loader, Pagination, Table, Warning } from "@culturehq/components";

import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";

import { createEntity, updateEntity, deleteEntity } from "./mutations";
import ProgramModal from "./programs/ProgramModal";
import ProgramRow from "./programs/ProgramRow";

const createProgram = createEntity("programs");
const updateProgram = updateEntity("programs");
const deleteProgram = deleteEntity("programs");

class Programs extends Component {
  state = { loading: true, programs: [] };

  componentDidMount() {
    const { match } = this.props;

    this.fetchPrograms(match.params.page || 1);
  }

  componentDidUpdate(prevProps) {
    const { match } = this.props;

    if (match.params.page !== prevProps.match.params.page) {
      this.fetchPrograms(match.params.page || 1);
    }
  }

  handlePageClick = page => {
    const { history } = this.props;

    history.push(`/admin/programs/${page}`);
  };

  handleCreate = program => {
    this.setState(createProgram(program));
  };

  handleUpdate = program => {
    this.setState(updateProgram(program));
  };

  handleDelete = program => {
    this.setState(deleteProgram(program));
  };

  async fetchPrograms(page) {
    this.setState({ loading: true });

    const { programs, pagination } = await client.listPrograms({ page });

    this.setState({ loading: false, programs, pagination });
  }

  render() {
    const { programs, loading, pagination } = this.state;

    return (
      <div className="padding-left-15px padding-right-15px">
        <ProgramModal onCreate={this.handleCreate}>
          {onTrigger => (
            <Button icon="plus" primary onClick={onTrigger}>
              <Trans>Add a Program</Trans>
            </Button>
          )}
        </ProgramModal>

        <PageHeader title={t("Manage Programs")}>
          <Trans>
            The below is a list of all the programs at your
            college. Users may select their programs. Program determine
            which events and notifications a user should receive.
          </Trans>
        </PageHeader>

        <Loader loading={loading}>
          <Table>
            <thead>
              <tr>
                <th>
                  <Trans>Name</Trans>
                </th>
                <th>
                  <Trans>Created</Trans>
                </th>
                <th>
                  <Trans>Updated</Trans>
                </th>
                <th className="actions">
                  <Trans>Actions</Trans>
                </th>
              </tr>
            </thead>
            <tbody>
              {programs.map(program => (
                <ProgramRow
                  key={program.id}
                  program={program}
                  onUpdate={this.handleUpdate}
                  onDelete={this.handleDelete}
                />
              ))}
            </tbody>
          </Table>

          {programs.length < 1 && (
            <Warning>
              <Trans>
                <strong>Uh oh!</strong> No results to show.
              </Trans>
            </Warning>
          )}

          <Pagination {...pagination} onClick={this.handlePageClick} />
        </Loader>
      </div>
    );
  }
}

export default Programs;
